module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wayo-1f09ac897635cc0ba6c44b99e030e1ee.webp";